import React, { useContext, useRef } from "react";
import { Button, Divider, Form, Input, Drawer, Space, Tooltip } from "antd";
import { useState } from "react";
import { notificationContext } from "../../Common/Routing/PageRoute";
import ItemCategoryService from "../../Services/ItemCategoryService";
import { useClient } from "../../Context/ClientContext";
import { CloseOutlined } from "@ant-design/icons";
import { useHotkey } from "../../Context/HotKeyContext";
import EntryLevelKeys from "../../Common/EntryLevelKeys";

interface IPropsTcs {
  open: boolean;
  onCancel: (value: boolean) => void;
  setTrigger?: React.Dispatch<React.SetStateAction<boolean>>;
  editData?: any;
  setAddCatVal?: any;
}

const AddCategoryItemsModel = (props: IPropsTcs) => {
  const { showKeys } = useHotkey();
  const { currentClient } = useClient();
  const [form] = Form.useForm();
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const autoCompleteRef = useRef<any>(null);

  React.useEffect(() => {
    if (props.editData?.id)
      form.setFieldsValue({ categoryName: props.editData.categoryName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editData]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []);

  const setCategory = () => {
    form.validateFields().then(async (value) => {
      try {
        setSaveButtonLoading(true);

        const res = await ItemCategoryService.postCategoryData(
          currentClient?.id,
          props?.editData?.id,
          value
        );
        console.log("result", res);

        if (res.status) {
          // debugger;
          props?.setAddCatVal && props.setAddCatVal(res?.result);
          openNotification(
            "success",
            `${
              props?.editData?.id
                ? "Item Category updated successfully."
                : "Item Category added successfully."
            }`
          );
          setSaveButtonLoading(false);
          props.onCancel(false);
          props?.setTrigger && props?.setTrigger((x: boolean) => !x);
        } else {
          setSaveButtonLoading(false);
          console.error("error", res?.message);
          res?.message && openNotification("error", res.message);
        }
      } catch (err: any) {
        // openNotification("error", err);
        console.error("error", err);
        err && openNotification("error", err);
        setSaveButtonLoading(false);
      }
    });
  };

  EntryLevelKeys({
    save: () => setCategory(),
    cancel: () => props.onCancel(false),
  });
  return (
    <Drawer
      maskClosable={false}
      title={props.editData?.id ? "Update Category Name" : "Add Category Name"}
      open={props.open}
      width={500}
      // centered
      // onOk={handleOk}
      closable={false}
      extra={
        <Space>
          <CloseOutlined onClick={() => props.onCancel(false)} />
        </Space>
      }
      onClose={() => props.onCancel(false)}
      footer={
        <div style={{ textAlign: "right" }}>
          <Tooltip title={<p>ALT+C</p>} placement="bottomLeft" open={showKeys}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel(false);
              }}
            >
              Cancel
            </Button>
          </Tooltip>

          <Tooltip title={<p>ALT+S</p>} placement="bottomLeft" open={showKeys}>
            <Button
              type="primary"
              onClick={() => setCategory()}
              style={{ width: "80px" }}
              loading={saveButtonLoading}
              className="modelSaveButtonMargin"
            >
              {props.editData?.id ? "Update" : "Save"}
            </Button>
          </Tooltip>
        </div>
      }
    >
      <Form
        form={form}
        layout="vertical"
        labelWrap={true}
        // labelCol={{ xs: 24, sm: 7 }}
        // wrapperCol={{ xs: 24, sm: 16 }}
        autoComplete="off"
        colon={false}
        labelAlign="left"
        requiredMark={true}
      >
        {/* <Divider className="ca-model-css" /> */}

        <Form.Item
          className="mb-14"
          // className="inputBoxMb8"
          name="categoryName"
          label="Category Name"
          rules={[{ required: true, message: "Category's name is required" }]}
        >
          <Input ref={autoCompleteRef} />
        </Form.Item>
        {/* </Spin> */}
        {/* <Divider /> */}
      </Form>
    </Drawer>
  );
};

export default AddCategoryItemsModel;
